// juno/companies/index.ts
import luma from "./luma.png";
import kling from "./kling.png";
import pika from "./pika.png";
import pixverse from "./pixverse.png";
import hailuo from "./hailuo.png";
import haiper from "./haiper.png";
import runway from "./runway.png";
import vidu from "./vidu.png";
import wan from "./wan.png";
import bytedance from "./bytedance.png";
import sync from "./sync.png";
import realesrgan from "./realesrgan.png";
import topazlabs from "./topazlabs.png";
import framepack from "./framepack.png";

import lumaThumbnail from "./luma-thumbnail.jpg";
import klingThumbnail from "./kling-thumbnail.jpg";
import pikaThumbnail from "./pika-thumbnail.jpg";
import pixverseThumbnail from "./pixverse-thumbnail.jpg";
import hailuoThumbnail from "./hailuo-thumbnail.jpg";
import haiperThumbnail from "./haiper-thumbnail.jpg";
import runwayThumbnail from "./runway-thumbnail.jpg";
import viduThumbnail from "./vidu-thumbnail.jpg";
import wanThumbnail from "./wan-thumbnail.jpg";

const JunoCompanies = {
  // ロゴ
  luma,
  kling,
  pika,
  pixverse,
  hailuo,
  haiper,
  runway,
  vidu,
  wan,
  bytedance,
  sync,
  realesrgan,
  topazlabs,
  framepack,

  // サムネイル
  lumaThumbnail,
  klingThumbnail,
  pikaThumbnail,
  pixverseThumbnail,
  hailuoThumbnail,
  haiperThumbnail,
  runwayThumbnail,
  viduThumbnail,
  wanThumbnail,
};

export default JunoCompanies;

// 個別エクスポート
export {
  luma as companyLuma,
  kling as companyKling,
  pika as companyPika,
  pixverse as companyPixverse,
  hailuo as companyHailuo,
  haiper as companyHaiper,
  runway as companyRunway,
  vidu as companyVidu,
  wan as companyWan,
  bytedance as companyBytedance,
  sync as companySync,
  realesrgan as companyRealesrgan,
  topazlabs as companyTopazlabs,
  framepack as companyFramepack,
  // サムネイル
  lumaThumbnail as junoCompanyLumaThumbnail,
  klingThumbnail as junoCompanyKlingThumbnail,
  pikaThumbnail as junoCompanyPikaThumbnail,
  pixverseThumbnail as junoCompanyPixverseThumbnail,
  hailuoThumbnail as junoCompanyHailuoThumbnail,
  haiperThumbnail as junoCompanyHaiperThumbnail,
  runwayThumbnail as junoCompanyRunwayThumbnail,
  viduThumbnail as junoCompanyViduThumbnail,
  wanThumbnail as junoCompanyWanThumbnail,
};
